'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./dialog-search.scss');

var _utils = require('../../utils');

var _dialog = require('../dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _iconButton = require('../icon-button');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _input = require('../input');

var _input2 = _interopRequireDefault(_input);

var _flexBox = require('../flex-box');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DialogSearch = function (_React$Component) {
  _inherits(DialogSearch, _React$Component);

  function DialogSearch(props) {
    _classCallCheck(this, DialogSearch);

    var _this = _possibleConstructorReturn(this, (DialogSearch.__proto__ || Object.getPrototypeOf(DialogSearch)).call(this, props));

    _this.state = {
      searchValue: '',
      activeElementIndex: 0,
      isOpen: false
    };

    _this.rows = [];
    _this.dialog = _react2.default.createRef();

    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    _this.onClickClose = _this.onClickClose.bind(_this);
    return _this;
  }

  _createClass(DialogSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.rows = this.dialog.current.querySelectorAll('.dialog-search__row');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.rows = this.dialog.current.querySelectorAll('.dialog-search__row');
    }
  }, {
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      var handleEnter = this.props.handleEnter;
      var activeElementIndex = this.state.activeElementIndex;

      var filteredData = this.getFilteredData();
      var limit = filteredData.length - 1;
      var newActiveElementIndex = 0;

      if (event.key === _utils.KEYS.ENTER && handleEnter) {
        handleEnter(filteredData[activeElementIndex]);
      }

      if ([_utils.KEYS.DOWN, _utils.KEYS.UP].includes(event.key)) {
        event.preventDefault();
      }

      if (event.key === _utils.KEYS.UP) {
        newActiveElementIndex = activeElementIndex <= 0 ? limit : activeElementIndex - 1;
        this.setState({ activeElementIndex: newActiveElementIndex });
      }

      if (event.key === _utils.KEYS.DOWN) {
        newActiveElementIndex = activeElementIndex >= limit ? 0 : activeElementIndex + 1;
        this.setState({ activeElementIndex: newActiveElementIndex });
      }

      if (this.rows.length) {
        this.dialog.current.scrollTop = newActiveElementIndex && this.rows[newActiveElementIndex].offsetTop;
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.setState({
        searchValue: '',
        isOpen: false
      });
      this.input.focus();
    }
  }, {
    key: 'getFilteredData',
    value: function getFilteredData() {
      var _props = this.props,
          indexKey = _props.indexKey,
          data = _props.data;
      var searchValue = this.state.searchValue;


      if (searchValue.length === 0) {
        return [];
      }

      if (this.props.customFilter) {
        return this.props.customFilter(data, searchValue);
      }

      return data.filter(function (row) {
        var searchableText = row[indexKey].toString().toLocaleLowerCase();

        return searchableText.search(searchValue.toLocaleLowerCase()) >= 0;
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(event) {
      var searchValue = event.target.value;

      this.setState({
        searchValue: searchValue,
        isOpen: Boolean(searchValue.length)
      });
    }
  }, {
    key: 'renderFilteredData',
    value: function renderFilteredData() {
      var _this2 = this;

      var _props2 = this.props,
          template = _props2.template,
          indexKey = _props2.indexKey,
          onClick = _props2.onClick;

      var filteredData = this.getFilteredData();

      if (filteredData.length === 0) {
        return _react2.default.createElement(
          'div',
          { className: 'dialog-search__row dialog-search__row--no-results' },
          this.props.noResultsText
        );
      }

      return filteredData.map(function (dataItem, i) {
        return _react2.default.createElement(
          'div',
          {
            key: i + '-' + dataItem[indexKey],
            onClick: onClick,
            className: (0, _utils.cn)('dialog-search__row', _this2.state.activeElementIndex === i ? 'dialog-search__row--active' : '')
          },
          template(dataItem)
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          placeholder = _props3.placeholder,
          props = _objectWithoutProperties(_props3, ['placeholder']);

      var classes = (0, _utils.cn)('dialog-search', this.state.isOpen && 'dialog-search__is-open');

      return (
        //  eslint-disable-next-line
        _react2.default.createElement(
          _dialog2.default,
          _extends({ open: true, className: classes, density: 'none', ref: this.dialog }, props),
          _react2.default.createElement(
            _flexBox.Flex,
            {
              align: 'center',
              gutter: 'xx-large',
              className: 'dialog-search__header',
              onKeyDown: this.onKeyDownHandler
            },
            _react2.default.createElement(_icon2.default, { name: 'search', size: '18', className: 'dialog-search__icon' }),
            _react2.default.createElement(_input2.default, {
              placeholder: placeholder,
              value: this.state.searchValue,
              className: 'dialog-search__input',
              size: 'x-large',
              onChange: this.handleSearch,
              onRefsReady: function onRefsReady(ref) {
                _this3.input = ref;
              },
              autoFocus: true
            }),
            this.state.searchValue.length !== 0 && _react2.default.createElement(_iconButton2.default, {
              icon: 'cross',
              shape: 'circle',
              size: 'small',
              className: 'dialog-search__icon dialog-search__icon--close',
              onClick: this.onClickClose
            })
          ),
          this.state.isOpen && this.renderFilteredData()
        )
      );
    }
  }]);

  return DialogSearch;
}(_react2.default.Component);

DialogSearch.propTypes = {
  data: _propTypes2.default.array,
  indexKey: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  template: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  handleEnter: _propTypes2.default.func,
  customFilter: _propTypes2.default.func,
  noResultsText: _propTypes2.default.string
};

DialogSearch.defaultProps = {
  data: [],
  noResultsText: 'No results found'
};

exports.default = DialogSearch;